import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../store';
import { changeNavigationAnchor, toggle as toggleNavigation } from '../../store/navigation';
import { IOfferCardNavigationDispatchProps, IOfferCardNavigationStoreProps, IProps } from './types';
import { fixedWithListenWindowScroll } from './highOrderComponents/fixedWithListenWindowScroll';
import { offerCardNavigation } from './highOrderComponents/offerCardNavigation';
import { Navigation } from './navigation';
import { itemBasedOffersVisible } from '../../utils/similarOffersVisible';
import {
  EBannerSimilarOffersExperiment,
  getBannerSimilarOffersExperiment,
} from '../../utils/bannerSimilarOffersExperiment';

export const mapStateToProps = (state: IState): IOfferCardNavigationStoreProps => ({
  isActive: state.aside.isNavigationActive,
  activeAnchor: state.aside.activeAnchor,
  isAgentAvailable: !!state.offerData.agent,
  isSimilarOffersAvailable:
    state.offerData.offer.status === 'published' &&
    getBannerSimilarOffersExperiment(state.abUseExperiments) === EBannerSimilarOffersExperiment.B &&
    itemBasedOffersVisible(state.similarOffers),
  offer: state.offerData.offer,
});

export const mapDispatchToProps = (dispatch: Dispatch<IState>): IOfferCardNavigationDispatchProps => ({
  toggleNavigation: (isActive: boolean) => dispatch(toggleNavigation(isActive)),
  changeNavigationAnchor: (anchor: string) => dispatch(changeNavigationAnchor(anchor)),
});

export const mergeProps = (
  stateProps: IOfferCardNavigationStoreProps,
  dispatchProps: IOfferCardNavigationDispatchProps,
  ownProps: IProps,
) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
});

export const OfferCardNavigationContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(fixedWithListenWindowScroll(offerCardNavigation(Navigation)));
